import React, { Fragment, useState, useCallback, useEffect, useRef } from 'react';
import DataTable from 'react-data-table-component';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { tableColumns } from './LiveStreamData';
import { Button, Modal, Form } from 'react-bootstrap';
import axios from 'axios';
import { toast } from 'react-toastify';
import { ServerPath } from '../../Constant';
import CreateLiveStream from './CreateLiveStream';
import EditLiveStream from './EditLiveStream';
import Search from '../../assets/images/svg/Search_SoS.svg';
import SearchIcon from '../../assets/images/svg/search_iconSos.svg';
import Calendar from '../../assets/images/svg/Calendar_SoS.svg';
import Filter from '../../assets/images/svg/Filter_SoS.svg';
import EditIcon from '../../assets/images/svg/editLearning.svg';
import ArchiveIcon from '../../assets/images/svg/archiveLearning.svg';
import ArchiveEnabled from '../../assets/images/svg/archiveEnabled.svg';
import Start from '../../assets/images/svg/play.svg';
import Stop from '../../assets/images/svg/stop.svg';

// Import date range picker
import { DateRange } from 'react-date-range';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';

// Custom styles for the data table
const tableStyles = `
  .rdt_TableCell {
    padding: 4px 2px !important;
  }
  .rdt_TableHead {
    padding: 4px 2px !important;
  }
  .rdt_TableCol {
    padding: 4px 2px !important;
  }
  .rdt_TableCell[data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .rdt_TableHeadRow [data-column-id="action"] {
    position: sticky !important;
    right: 0 !important;
    background-color: inherit !important;
    z-index: 1;
  }
  .data-tables {
    overflow-x: auto;
  }
  .btn[title]:hover:after {
    content: attr(title);
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translateX(-50%);
    padding: 4px 8px;
    color: white;
    border-radius: 4px;
    font-size: 12px;
    white-space: nowrap;
  }
  .btn[title] {
    position: relative;
  }
  .btn-link:hover {
    text-decoration: none !important;
  }
  .btn[disabled] {
    cursor: not-allowed;
  }
`;

// Main component
const LiveStreamTable = () => {
    const [selectedRows, setSelectedRows] = useState([]);
    const [toggleDelete, setToggleDelete] = useState(false);
    const [data, setData] = useState([]);
    const [showCreate, setShowCreate] = useState(false);
    const [showEdit, setShowEdit] = useState(false);
    const [editRowData, setEditRowData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [loading, setLoading] = useState(false);
    const [totalRows, setTotalRows] = useState(0);
    const [showModal, setShowModal] = useState(false);
    const [modalConfig, setModalConfig] = useState({
        type: '',
        title: '',
        message: '',
        // object_id: null, 
        stream_id: null,
        stream_key: null
    });

    // Search, calendar, and filter state
    const [originalData, setOriginalData] = useState([]);
    const [showSearch, setShowSearch] = useState(false);
    const [searchValue, setSearchValue] = useState('');
    const searchRef = useRef(null);
    const [showDropdown, setShowDropdown] = useState(false);
    const dropdownRef = useRef(null);
    const [selectedFilter, setSelectedFilter] = useState('all');
    const [showCalendar, setShowCalendar] = useState(false);
    const calendarRef = useRef(null);
    const [dateRange, setDateRange] = useState([
        {
            startDate: null,
            endDate: null,
            key: 'selection'
        }
    ]);

    const filterOptions = [
        { label: 'All', value: 'all' },
        { label: 'YouTube Only', value: 'youtube' },
        { label: 'CCTV Only', value: 'cctv' },
        { label: 'Active Streams', value: 'active' },
        { label: 'Archived Streams', value: 'archived' },
        { label: 'Featured', value: 'featured' },
        { label: 'Temple Streams', value: 'temple' },
        { label: 'Saint Streams', value: 'saint' },
        { label: 'Live Darshan', value: 'live_darshan' },    // Add this
        { label: 'Live Stream', value: 'live_stream' },      // Add this
        { label: 'Live Aarti', value: 'live_aarti' }         // Add this
    ];

    // Click outside handlers
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (searchRef.current && !searchRef.current.contains(event.target)) {
                setShowSearch(false);
            }
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
            if (calendarRef.current && !calendarRef.current.contains(event.target)) {
                setShowCalendar(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    // Fetch data from API
    // Fetch data from API
    // Fetch data from API
    const fetchStreams = async () => {
        try {
            setLoading(true);
            const response = await axios.get(`${ServerPath}/live-darshan/all`);

            if (response.data.success === 1) {
                const transformedData = response.data.data.map(item => {
                    const rawData = { ...item };

                    // Determine stream identifier based on type
                    const streamIdentifier = item.streamType === 'youtube'
                        ? item.youtube?.videoId
                        : item.cctv?.streamKey;

                    // ✅ Get display name based on object type
                    const displayName = item.objectType === 'temple'
                        ? (item.objectName || item.streamTitle)
                        : (item.objectName || item.streamTitle);

                    return {
                        id: item.id,
                        wpt_id: item.wptId,
                        object_type: item.objectType, // ✅ Add this
                        object_id: item.objectId, // ✅ Add this
                        stream_type: item.streamType,
                        stream_key: item.cctv?.streamKey || null,
                        youtube_video_id: item.youtube?.videoId || null,
                        rtsp_url: item.cctv?.rtspUrl || null,
                        hls_url: item.cctv?.hlsUrl || null,
                        stream_title: item.streamTitle,
                        stream_title_mar: item.streamTitleMar,
                        stream_title_hin: item.streamTitleHin,
                        stream_title_guj: item.streamTitleGuj,
                        temple_name: displayName, // ✅ Use displayName (works for both temple and saint)
                        stream_identifier: streamIdentifier,
                        thumbnail_url: item.thumbnailUrl,
                        is_active: item.isActive ? 1 : 0,
                        stream_status: item.cctv?.streamStatus || 'N/A',
                        is_featured: item.isFeatured ? 1 : 0,
                        stream_category: item.streamCategory || 'live_darshan',
                        created_at: item.createdAt
                            ? new Date(item.createdAt).toLocaleDateString('en-GB')
                            : 'N/A',
                        updated_at: item.updated_at,
                        original_created_at: item.createdAt
                            ? new Date(item.createdAt)
                            : null,
                        action: (
                            <div className="d-flex justify-content-center gap-2">
                                {/* CCTV-specific Start/Stop icon buttons */}
                                {item.streamType === 'cctv' && (
                                    <>
                                        {item.cctv?.streamStatus === 'active' ? (
                                            <button
                                                className="btn btn-link p-0"
                                                title="Stop Stream"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setModalConfig({
                                                        type: 'stop',
                                                        title: 'Stop CCTV Stream',
                                                        message: `Are you sure you want to stop the CCTV stream for "${item.streamTitle}"?`,
                                                        stream_id: item.id  // ✅
                                                    });
                                                    setShowModal(true);
                                                }}
                                                style={{
                                                    backgroundColor: '#FF4444',
                                                    borderRadius: '6px',
                                                    padding: '6px',
                                                    border: 'none',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <img src={Stop} alt="stop" style={{ width: '24px', height: '24px' }} />
                                            </button>
                                        ) : (
                                            <button
                                                className="btn btn-link p-0"
                                                title="Start Stream"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    setModalConfig({
                                                        type: 'start',
                                                        title: 'Start CCTV Stream',
                                                        message: `Are you sure you want to start the CCTV stream for "${item.streamTitle}"?`,
                                                        stream_id: item.id // ✅
                                                    });
                                                    setShowModal(true);
                                                }}
                                                style={{
                                                    backgroundColor: '#4CAF50',
                                                    borderRadius: '6px',
                                                    padding: '6px',
                                                    border: 'none',
                                                    display: 'flex',
                                                    alignItems: 'center',
                                                    justifyContent: 'center',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                <img src={Start} alt="start" style={{ width: '24px', height: '24px' }} />
                                            </button>
                                        )}
                                    </>
                                )}

                                {/* Common Edit icon button */}
                                <button
                                    className="btn btn-link p-0"
                                    title="Edit"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        handleEdit(rawData);
                                    }}
                                >
                                    <img src={EditIcon} alt="edit" style={{ width: '24px', height: '24px' }} />
                                </button>

                                {/* Archive icon button */}
                                <div title={item.isActive ? "Archive" : "Archived"}>
                                    <button
                                        className="btn btn-link p-0"
                                        disabled={!item.isActive}
                                        onClick={(e) => {
                                            e.stopPropagation();
                                            if (item.isActive) {
                                                setModalConfig({
                                                    type: 'archive',
                                                    title: 'Archive Stream',
                                                    message: `Are you sure you want to archive the stream for "${item.streamTitle}"? Once archived, it will no longer be visible to users.`,
                                                    stream_id: item.id  // ✅
                                                });
                                                setShowModal(true);
                                            }
                                        }}
                                        style={{ opacity: !item.isActive ? 0.5 : 1 }}
                                    >
                                        <img
                                            src={!item.isActive ? ArchiveEnabled : ArchiveIcon}
                                            alt="archive"
                                            style={{ width: '24px', height: '24px' }}
                                        />
                                    </button>
                                </div>
                            </div>
                        ),
                        raw_data: rawData
                    };
                });

                setData(transformedData);
                setOriginalData(transformedData);
                setTotalRows(transformedData.length);
            } else {
                toast.error('Failed to fetch streams');
            }
        } catch (error) {
            console.error('Error fetching streams:', error);
            toast.error('Error fetching streams');
        } finally {
            setLoading(false);
        }
    };

    // Load data on component mount
    useEffect(() => {
        fetchStreams();
    }, []);

    // Search, filter and date range functions
    const handleSearch = (value) => {
        setSearchValue(value);
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(value, selectedFilter, currentDateRange);
    };

    const handleFilterChange = (value) => {
        setSelectedFilter(value);
        const currentDateRange = dateRange[0]?.startDate && dateRange[0]?.endDate ? dateRange[0] : null;
        applyFiltersAndSearch(searchValue, value, currentDateRange);
        setShowDropdown(false);
    };

    const handleDateRangeChange = (item) => {
        setDateRange([item.selection]);
        applyFiltersAndSearch(searchValue, selectedFilter, item.selection);
    };

    const clearDateFilter = () => {
        const clearedRange = {
            startDate: null,
            endDate: null,
            key: 'selection'
        };
        setDateRange([clearedRange]);
        applyFiltersAndSearch(searchValue, selectedFilter, null);
        setShowCalendar(false);
    };

    const applyFiltersAndSearch = (searchValue, filterValue, dateValue) => {
        let filteredData = [...originalData];

        // Apply search filter
        if (searchValue && searchValue.trim()) {
            const searchTerm = searchValue.toLowerCase();
            filteredData = filteredData.filter(item => {
                return (
                    String(item.temple_name || '').toLowerCase().includes(searchTerm) ||
                    String(item.stream_title || '').toLowerCase().includes(searchTerm) ||
                    String(item.stream_identifier || '').toLowerCase().includes(searchTerm) ||
                    String(item.stream_type || '').toLowerCase().includes(searchTerm)
                );
            });
        }

        // Apply type/status filter
        if (filterValue && filterValue !== 'all') {
            switch (filterValue) {
                case 'youtube':
                    filteredData = filteredData.filter(item => item.stream_type === 'youtube');
                    break;
                case 'cctv':
                    filteredData = filteredData.filter(item => item.stream_type === 'cctv');
                    break;
                case 'active':
                    filteredData = filteredData.filter(item => item.is_active === 1);
                    break;
                case 'archived':
                    filteredData = filteredData.filter(item => item.is_active === 0);
                    break;
                case 'featured':
                    filteredData = filteredData.filter(item => item.is_featured === 1);
                    break;
                case 'temple': // ✅ Add this
                    filteredData = filteredData.filter(item => item.object_type === 'temple');
                    break;
                case 'saint': // ✅ Add this
                    filteredData = filteredData.filter(item => item.object_type === 'saint');
                    break;
                case 'live_darshan':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_darshan');
                    break;
                case 'live_stream':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_stream');
                    break;
                case 'live_aarti':
                    filteredData = filteredData.filter(item => item.stream_category === 'live_aarti');
                    break;
                default:
                    break;
            }
        }

        // Apply date filter
        if (dateValue?.startDate && dateValue?.endDate) {
            filteredData = filteredData.filter(item => {
                if (!item.original_created_at) return false;
                const startDate = new Date(dateValue.startDate);
                startDate.setHours(0, 0, 0, 0);
                const endDate = new Date(dateValue.endDate);
                endDate.setHours(23, 59, 59, 999);
                return item.original_created_at >= startDate && item.original_created_at <= endDate;
            });
        }

        setData(filteredData);
    };
    // Handle stream operations
    const handleStartCCTVStream = async (stream_id) => {
        console.log('🎬 Starting CCTV stream with ID:', stream_id);  // ✅ Add this

        try {
            const response = await axios.post(`${ServerPath}/live-darshan/cctv/start`, {
                stream_id: stream_id
            });

            console.log('📡 Backend response:', response.data);  // ✅ Add this

            if (response.data.success === 1) {
                window.location.reload();
                toast.success('CCTV stream started successfully');
                fetchStreams();
            } else {
                toast.error(response.data.message || 'Failed to start CCTV stream');
            }
        } catch (error) {
            console.error('❌ Error starting CCTV stream:', error);
            console.error('Error response:', error.response?.data);  // ✅ Add this
            toast.error(error.response?.data?.message || 'Error starting CCTV stream');
        }
    };

    const handleStopCCTVStream = async (stream_id) => {
        console.log('🎬 Stopping CCTV stream with ID:', stream_id);
        try {
            const response = await axios.post(`${ServerPath}/live-darshan/cctv/stop`, {
                stream_id: stream_id
            });
            console.log('📡 Backend response:', response.data);
            if (response.data.success === 1) {
                window.location.reload();
                toast.success('CCTV stream stopped successfully');
                fetchStreams();
            } else {
                toast.error(response.data.message || 'Failed to stop CCTV stream');
            }
        } catch (error) {
            console.error('Error stopping CCTV stream:', error);
            toast.error(error.response?.data?.message || 'Error stopping CCTV stream');
        }
    };

    const handleArchiveStream = async (stream_id) => {
        try {
            setLoading(true);

            // Use existing updateStatus endpoint to set is_active = 0
            const response = await axios.post(`${ServerPath}/live-darshan/update-status`, {
                stream_id: stream_id,
                is_active: 0
            });

            if (response.data.success === 1) {
                // Update the local data
                const updatedData = data.map(item =>
                    item.id === stream_id
                        ? { ...item, is_active: 0 }
                        : item
                );

                setData(updatedData);
                setOriginalData(prevData =>
                    prevData.map(item =>
                        item.id === stream_id
                            ? { ...item, is_active: 0 }
                            : item
                    )
                );

                toast.success('Stream has been successfully archived');
            } else {
                toast.error(response.data.message || 'Failed to archive stream');
            }
        } catch (error) {
            console.error('Error archiving stream:', error);
            toast.error(error.response?.data?.message || 'Error archiving stream');
        } finally {
            setLoading(false);
        }
    };

    // Handle edit action
    // Handle edit action
    const handleEdit = (rawData) => {
        console.log('Edit row data (raw):', rawData);

        // Transform camelCase API data to snake_case for edit form
        const editData = {
            id: rawData.id,
            wpt_id: rawData.wptId || rawData.wpt_id,
            object_type: rawData.objectType || rawData.object_type || 'temple', // ✅ Add this
            object_id: rawData.objectId || rawData.object_id, // ✅ Add this
            stream_type: rawData.streamType || rawData.stream_type,
            stream_category: rawData.streamCategory || rawData.stream_category || 'live_darshan',

            // YouTube fields
            youtube_video_id: rawData.youtube?.videoId || rawData.youtube_video_id || '',

            // CCTV fields
            stream_key: rawData.cctv?.streamKey || rawData.stream_key || '',
            rtsp_url: rawData.cctv?.rtspUrl || rawData.rtsp_url || '',
            hls_url: rawData.cctv?.hlsUrl || rawData.hls_url || '',
            stream_status: rawData.cctv?.streamStatus || rawData.stream_status || 'inactive',

            // Shared fields
            stream_title: rawData.streamTitle || rawData.stream_title || '',
            stream_title_mar: rawData.streamTitleMar || rawData.stream_title_mar || '',
            stream_title_hin: rawData.streamTitleHin || rawData.stream_title_hin || '',
            stream_title_guj: rawData.streamTitleGuj || rawData.stream_title_guj || '',
            thumbnail_url: rawData.thumbnailUrl || rawData.thumbnail_url || '',

            is_active: rawData.isActive !== undefined ? (rawData.isActive ? 1 : 0) : (rawData.is_active !== undefined ? rawData.is_active : 1),
            is_featured: rawData.isFeatured !== undefined ? (rawData.isFeatured ? 1 : 0) : (rawData.is_featured !== undefined ? rawData.is_featured : 0),

            created_at: rawData.created_at,
            updated_at: rawData.updated_at,

            // ✅ Add temple_name for display purposes
            temple_name: rawData.objectName || rawData.temple_name || ''
        };

        console.log('Edit data (transformed):', editData);
        setEditRowData(editData);
        setShowEdit(true);
    };

    // Handle row selection
    const handleRowSelected = useCallback(state => {
        setSelectedRows(state.selectedRows);
    }, []);

    // Handle pagination
    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setPerPage(newPerPage);
        setCurrentPage(page);
    };

    // Handle modal confirmation
    const handleModalConfirm = async () => {
        if (modalConfig.type === 'start') {
            await handleStartCCTVStream(modalConfig.stream_id);
        } else if (modalConfig.type === 'stop') {
            await handleStopCCTVStream(modalConfig.stream_id);
        } else if (modalConfig.type === 'archive') {
            await handleArchiveStream(modalConfig.stream_id);
        }
        setShowModal(false);
    };

    // Component closing handlers
    const handleEditClose = () => {
        setShowEdit(false);
        setEditRowData(null);
        fetchStreams();
    };

    const handleCreateClose = () => {
        setShowCreate(false);
        fetchStreams();
    };

    return (
        <Fragment>
            <style>{tableStyles}</style>
            <Container fluid={true}>
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3 className="mb-0">Live Temple Darshan Management</h3>
                    <div className="d-flex align-items-center gap-3">
                        {/* Search Component */}
                        <div className="position-relative" ref={searchRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowSearch(true)}
                            >
                                <img src={Search} alt="search" style={{ width: '36px', height: '36px' }} />
                            </button>
                            {showSearch && (
                                <div
                                    style={{
                                        position: 'absolute',
                                        top: '45px',
                                        left: '-180px',
                                        width: '220px',
                                        zIndex: 1000
                                    }}
                                >
                                    <div
                                        style={{
                                            background: 'white',
                                            borderRadius: '8px',
                                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                            padding: '8px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: '8px'
                                        }}
                                    >
                                        <div
                                            style={{
                                                flex: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                background: '#F8F7FA',
                                                borderRadius: '6px',
                                                padding: '6px 12px'
                                            }}
                                        >
                                            <input
                                                type="text"
                                                placeholder="Search Here..."
                                                value={searchValue}
                                                onChange={(e) => handleSearch(e.target.value)}
                                                style={{
                                                    width: '100%',
                                                    border: 'none',
                                                    background: 'transparent',
                                                    fontSize: '14px',
                                                    color: '#666',
                                                    outline: 'none'
                                                }}
                                                autoFocus
                                            />
                                            <button
                                                style={{
                                                    background: 'none',
                                                    border: 'none',
                                                    padding: 0,
                                                    cursor: 'pointer',
                                                    display: 'flex',
                                                    alignItems: 'center'
                                                }}
                                                onClick={() => handleSearch(searchValue)}
                                            >
                                                <img src={SearchIcon} alt="search" style={{ width: '20px', height: '20px' }} />
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Calendar Component */}
                        <div className="position-relative" ref={calendarRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowCalendar(!showCalendar)}
                            >
                                <img src={Calendar} alt="calendar" style={{ width: '36px', height: '36px' }} />
                            </button>
                            {showCalendar && (
                                <div
                                    className="position-absolute end-0 mt-2 bg-white rounded shadow p-3"
                                    style={{
                                        width: 'auto',
                                        maxWidth: '300px',
                                        zIndex: 1000,
                                        right: 0
                                    }}
                                >
                                    <style>
                                        {`
                                            .date-range {
                                                font-size: 12px !important;
                                            }
                                            .date-range .rdrMonth {
                                                width: 240px !important;
                                                padding: 0 !important;
                                            }
                                            .date-range .rdrCalendarWrapper {
                                                font-size: 12px !important;
                                                width: 240px !important;
                                                border-radius: 8px !important;
                                                overflow: hidden !important;
                                                background: white !important;
                                            }
                                            .date-range .rdrDateDisplayWrapper {
                                                display: none !important;
                                            }
                                            .rdrMonthAndYearWrapper {
                                                padding-top: 5px !important;
                                                height: 40px !important;
                                            }
                                            .rdrMonth {
                                                padding: 0 !important;
                                            }
                                        `}
                                    </style>
                                    <DateRange
                                        editableDateInputs={true}
                                        onChange={handleDateRangeChange}
                                        moveRangeOnFirstSelection={false}
                                        ranges={dateRange}
                                        maxDate={new Date()}
                                        months={1}
                                        direction="horizontal"
                                        className="date-range"
                                        staticRanges={[]}
                                        inputRanges={[]}
                                        rangeColors={['#0066ff']}
                                        minDate={new Date("2000-01-01")}
                                        showSelectionPreview={true}
                                        showMonthAndYearPickers={true}
                                        monthDisplayFormat="MMMM yyyy"
                                        dayDisplayFormat="d"
                                        showDateDisplay={false}
                                        monthsShown={1}
                                    />
                                    <div className="d-flex justify-content-end mt-2">
                                        <Button
                                            variant="outline-secondary"
                                            size="sm"
                                            onClick={clearDateFilter}
                                        >
                                            Clear
                                        </Button>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Filter Component */}
                        <div className="position-relative" ref={dropdownRef}>
                            <button
                                className="bg-transparent border-0"
                                onClick={() => setShowDropdown(!showDropdown)}
                            >
                                <img src={Filter} alt="filter" style={{ width: '36px', height: '36px' }} />
                            </button>
                            {showDropdown && (
                                <div className="position-absolute end-0 mt-2 bg-white rounded shadow p-2"
                                    style={{ width: '200px', zIndex: 1000 }}>
                                    <style>
                                        {`
                                            .form-check-label {
                                                font-weight: 400 !important;
                                            }
                                            .form-check-input[type=checkbox] {
                                                border-radius: 0 !important;
                                            }
                                        `}
                                    </style>
                                    <Form>
                                        {filterOptions.map((option) => (
                                            <Form.Check
                                                key={option.value}
                                                type="checkbox"
                                                name="filterOption"
                                                id={`filter-${option.value}`}
                                                label={option.label}
                                                checked={selectedFilter === option.value}
                                                onChange={() => handleFilterChange(option.value)}
                                            />
                                        ))}
                                    </Form>
                                </div>
                            )}
                        </div>

                        {/* Create Button */}
                        <Button
                            variant="primary"
                            onClick={() => setShowCreate(true)}
                            className="bg-primary"
                        >
                            Add New Stream
                        </Button>
                    </div>
                </div>

                <Row>
                    <Col sm="12">
                        <Card>
                            <CardBody>
                                <DataTable
                                    columns={tableColumns}
                                    data={data}
                                    selectableRows
                                    pagination
                                    paginationServer={false}
                                    paginationTotalRows={totalRows}
                                    onChangePage={handlePageChange}
                                    onChangeRowsPerPage={handlePerRowsChange}
                                    onSelectedRowsChange={handleRowSelected}
                                    clearSelectedRows={toggleDelete}
                                    progressPending={loading}
                                    highlightOnHover
                                    responsive
                                />
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            </Container>

            {/* Create Stream Modal */}
            {showCreate && <CreateLiveStream show={showCreate} onHide={handleCreateClose} />}

            {/* Edit Stream Modal */}
            {showEdit && <EditLiveStream
                key={editRowData?.id || 'new-edit'}
                show={showEdit}
                onHide={handleEditClose}
                streamData={editRowData}
            />}

            {/* Confirmation Modal */}
            <ConfirmationModal
                show={showModal}
                onHide={() => setShowModal(false)}
                onConfirm={handleModalConfirm}
                title={modalConfig.title}
                message={modalConfig.message}
            />
        </Fragment>
    );
};

// Confirmation Modal Component
const ConfirmationModal = ({ show, onHide, onConfirm, title, message }) => (
    <Modal show={show} onHide={onHide} centered>
        <Modal.Body className="text-center p-4">
            <div className="mb-4">
                <div className="rounded-circle bg-warning bg-opacity-10 d-inline-flex p-4 mb-3">
                    <i className="bi bi-exclamation-lg fs-4 text-warning"></i>
                </div>
                <h4>{title}</h4>
                <p className="text-secondary mb-0">{message}</p>
            </div>
            <div className="d-flex gap-2 justify-content-center">
                <Button variant="primary" className="px-4" onClick={onConfirm}>Yes</Button>
                <Button variant="danger" className="px-4" onClick={onHide}>Cancel</Button>
            </div>
        </Modal.Body>
    </Modal>
);

export default LiveStreamTable;